import { useGetSellersQuery } from 'services/api';
import styled from 'styled-components';
import { ContainedFormReactSelect } from '../../../Form/FinalForm/Contained/ContainedFormReactSelect';
import { AUCTION_TYPES } from 'constants';
import { required } from 'utils/validators';
import { useField } from 'react-final-form';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 60px;
  div:first-child {
    flex: 1 1 80%;
  }
`;

export const auctionTypeOptions = [
  {
    label: 'Autoaxess',
    value: AUCTION_TYPES.AUTOAXESS
  },
  {
    label: 'Second Chance',
    value: AUCTION_TYPES.SECOND_CHANCE
  },
  {
    label: 'Frontline',
    value: AUCTION_TYPES.FRONTLINE
  }
];

export const AuctionField = () => {
  const {
    input: { value: status }
  } = useField('status', { subscription: { value: true } });
  return (
    <Wrapper>
      <ContainedFormReactSelect
        validate={required}
        disabled={status === 'active'}
        label="Auction"
        name="auction_type"
        options={auctionTypeOptions}
      />
    </Wrapper>
  );
};
